<div class="flex flex-col gap-3 p-3">
  <div
    class="flex flex-wrap items-center justify-between gap-2 whitespace-nowrap"
  >
    <ag1-title label="404 Error" />
  </div>
  <div
    class="grid h-[calc(100vh-13rem)] place-items-center gap-2 overflow-y-auto @container"
  >
    <ng-container *ngTemplateOutlet="fourOhFourDisplay" />
  </div>
</div>

<ng-template #fourOhFourDisplay>
  <div>
    <div
      class="grid h-full max-w-4xl grid-cols-1 items-center justify-items-center gap-10 overflow-visible p-5 @lg:grid-cols-2"
    >
      <!-- left -->
      <div
        class="row-start-2 flex max-w-lg flex-col items-center text-center @lg:row-start-1 @lg:items-start @lg:text-start"
      >
        <h1 class="text-5xl font-extrabold text-steel-blue-600">
          Page Not Found
        </h1>
        <p class="mt-5 text-xl text-gray-600">
          Whoops! It seems the page
          @if (previousUrl) {
            <b class="font-semibold">"{{ previousUrl }}"</b>
          }
          @if (!previousUrl) {
            you're searching for
          }
          is not available or missing. Feel free to contact us if you feel
          something is incorrect.
        </p>
        <p class="mt-5 font-semibold">Error code: 404</p>
        <div class="mt-5 flex items-center gap-3">
          <p-button label="Go Back" (click)="goBack()" />
          <p-button severity="secondary" (click)="goHome()" label="Go Home" />
        </div>
      </div>

      <!-- right -->
      <div class="relative row-start-1 h-fit max-h-fit w-fit p-1">
        <p
          class="absolute left-3 top-3 z-10 scale-150 text-9xl text-orange-500/40"
        >
          4
        </p>
        <img
          src="/assets/images/error_images/404-orange-bg.png"
          alt="404 Image"
          class="relative z-20"
        />
        <p
          class="absolute bottom-0 right-0 z-10 scale-150 text-9xl text-orange-500/40"
        >
          4
        </p>
      </div>
    </div>
  </div>
</ng-template>
